import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {BackendHttpService} from '../../core/backend-http.service';
import {apiEndpoints} from '../../app.constants';
import {ObjectUtils} from '../../utils/object.utils';
import {BlockedReason, InvalidAction, User, WallType} from '../../../models/user';
import {UserService} from '../../services/user.service';
import {
  EventTrackerService,
  Page,
  TargetType,
  UserActionType
} from '../../services/event-tracker/event-tracker.service';

@Injectable()
export class PdfViewerService extends BackendHttpService<any> {

  constructor(protected router: Router,
              protected translate: TranslateService,
              private eventTracker: EventTrackerService,
              private userService: UserService) {
    super(router, translate);
  }

  private getUserToken() {
    if (!localStorage.getItem('user')) {
      return null;
    }
    const user = ObjectUtils.parseJSON(localStorage.getItem('user')) as User;
    return user.token;
  }

  /**
   * to get influencer details pdf file
   * @param influencerId
   * @returns {file}
   */
  public generateInfluencerDetailPdf(influencerId, demographicChannel, activeAccountId, channelFollowerId, insightChannelParam): any {
    let params = {activeAccount: activeAccountId, accessToken: this.getUserToken()};
    // add channel in pdf url
    if (demographicChannel) {
      params = Object.assign({}, params, {
        demographicChannel: demographicChannel
      });
    }
    if (insightChannelParam) {
      params = Object.assign({}, params, {
        insightChannel: insightChannelParam
      });
    }
    if (channelFollowerId) {
      params = Object.assign({}, params, {
        channelFollower: channelFollowerId
      });
    }
    return this.get(apiEndpoints.generateInfluencerDetailPdf + influencerId, params)
      .map((res: any) => {
        return res;
      });
  }
  /**
   * generate campaign pdf file
   * @param influencerId
   * @returns {file}
   */
  public generateCampaignPdf(campaignInfluencerId): any {
    const params = {accessToken: this.getUserToken()};
    return this.get(apiEndpoints.generateCampaignPdf + campaignInfluencerId, params)
      .map((res: any) => {
        return res;
      });
  }

  /**
   * to get post overview pdf file
   * @param data
   * @returns {file}
   */
  public generatePostOverviewPdf(data, activeAccountId): any {
    const tokenObj = {accessToken: this.getUserToken(), activeAccount: activeAccountId};
    const params = Object.assign(tokenObj, data);
    return this.get(apiEndpoints.generatePostOverviewPdf, params)
      .map((res: any) => {
        return res;
      });
  }

  /**
   * to get measure pdf file
   * @param data
   * @returns {file}
   */
  public generateMeasurePdf(data, activeAccountId): any {
    const tokenObj = {accessToken: this.getUserToken(), activeAccount: activeAccountId};
    const params = Object.assign(tokenObj, data);
    return this.get(apiEndpoints.generateMeasurePdf, params)
      .map((res: any) => {
        return res;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/main/pdf-viewer/pdf-viewer.service.ts